var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen-lock-loader"},[_c('div',{staticClass:"overlay-close"}),_c('div',{staticClass:"spinner-card"},[_c('spinner',{attrs:{"width":"100","height":"100"}}),_c('p',[_vm._v("Processing")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }